import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FemaleAvatarIcon } from './Icons';
const MESSAGES = [{
  name: 'Emily',
  city: 'Austin',
  action: 'just joined the program'
}, {
  name: 'Sarah',
  city: 'Chicago',
  action: 'just purchased'
}, {
  name: 'Jennifer',
  city: 'Denver',
  action: 'just got access'
}, {
  name: 'Michelle',
  city: 'Seattle',
  action: 'just joined'
}];
const INITIAL_DELAY = 15000; // 15s before first notification
const VISIBLE_DURATION = 4000; // 4s visible on screen
const GAP_DURATION = 55000; // 55s gap between notifications
export const SocialProofNotification = () => {
  const [currentIndex, setCurrentIndex] = useState<number | null>(null);
  useEffect(() => {
    const timers: ReturnType<typeof setTimeout>[] = [];
    const cycle = (index: number) => {
      if (index >= MESSAGES.length) return; // stop after 4
      // Show
      setCurrentIndex(index);
      // Hide after VISIBLE_DURATION
      const hideTimer = setTimeout(() => {
        setCurrentIndex(null);
        // Wait GAP_DURATION, then trigger next
        const nextTimer = setTimeout(() => {
          cycle(index + 1);
        }, GAP_DURATION);
        timers.push(nextTimer);
      }, VISIBLE_DURATION);
      timers.push(hideTimer);
    };
    // First appearance: wait INITIAL_DELAY
    const firstTimer = setTimeout(() => cycle(0), INITIAL_DELAY);
    timers.push(firstTimer);
    return () => {
      timers.forEach(clearTimeout);
    };
  }, []);
  const message = currentIndex !== null ? MESSAGES[currentIndex] : null;
  return <div className="fixed z-[9999] pointer-events-none" style={{
    bottom: '12px',
    left: '12px'
  }} data-id="element-158">
      <div className="md:!bottom-6 md:!left-6 hidden" data-id="element-159" />
      <AnimatePresence data-id="element-160">
        {message && <motion.div key={currentIndex} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.4,
          ease: 'easeOut'
        }
      }} exit={{
        opacity: 0,
        y: 10,
        transition: {
          duration: 0.3,
          ease: 'easeIn'
        }
      }} className="bg-white rounded-[10px] flex items-center gap-3 pointer-events-auto" style={{
        borderLeft: '4px solid #957DAD',
        boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
        padding: '14px 18px',
        maxWidth: typeof window !== 'undefined' && window.innerWidth <= 768 ? '240px' : '280px'
      }} data-id="element-161">
            <div className="flex-shrink-0 inline-flex items-center justify-center" style={{
          width: '36px',
          height: '36px',
          background: '#E0BBE4',
          borderRadius: '50%'
        }} aria-hidden="true" data-id="element-162">
              <FemaleAvatarIcon color="#957DAD" size={22} data-id="element-163" />
            </div>
            <div className="flex flex-col min-w-0" data-id="element-164">
              <span className="font-lato font-bold leading-tight" style={{
            fontSize: '13px',
            color: '#333333'
          }} data-id="element-165">
                {message.name} from {message.city}
              </span>
              <span className="font-lato leading-tight mt-0.5" style={{
            fontSize: '12px',
            color: '#777777'
          }} data-id="element-166">
                {message.action}
              </span>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};